'use client';

export default function Navbar() {
  const handleSignupClick = () => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'signup_click', { event_category: 'conversion', event_label: 'landing_page' });
    }
  };
  const handleLoginClick = () => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'login_click', { event_category: 'engagement', event_label: 'landing_page' });
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="container">
        <div className="flex items-center justify-between h-14 sm:h-16 px-4 sm:px-6">
          <a href="/" className="flex items-center min-w-0">
            <img src="/images/logo/logo.png" alt="InfluenceHub Logo" className="h-6 sm:h-8 w-auto mr-2 sm:mr-3 flex-shrink-0" />
            <span className="text-lg sm:text-2xl font-bold text-dark font-dm-sans truncate">InfluenceHub</span>
          </a>
          <div className="hidden md:flex items-center space-x-6">
            <a href="/#how-it-works" className="text-gray-600 hover:text-dark transition-colors font-dm-sans">How it works</a>
            <a href="/influencer-contract-checker" className="text-gray-600 hover:text-dark transition-colors font-dm-sans">Contract checker</a>
            <a href="/login" className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition font-dm-sans" onClick={handleLoginClick}>
              Log In
            </a>
            <a href="/signup" className="px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary/90 transition font-dm-sans" onClick={handleSignupClick}>
              Create your profile →
            </a>
          </div>
          <div className="md:hidden flex items-center gap-x-2 min-w-0 flex-wrap justify-end">
            <a
              href="/#how-it-works"
              className="text-xs font-medium text-gray-600 hover:text-dark font-dm-sans whitespace-nowrap shrink-0"
            >
              How it works
            </a>
            <a
              href="/influencer-contract-checker"
              className="text-xs font-medium text-primary hover:text-primary/80 font-dm-sans truncate max-w-[7.5rem] shrink"
              title="Influencer contract checker"
            >
              Contract checker
            </a>
            <a href="/signup" className="px-3 py-2 rounded-lg bg-primary text-white hover:bg-primary/90 transition text-sm font-dm-sans whitespace-nowrap min-h-[44px] flex items-center shrink-0" onClick={handleSignupClick}>
              Sign Up
            </a>
            <a href="/" className="p-2 rounded-lg text-gray-600 hover:text-dark hover:bg-gray-100" aria-label="Menu">
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
